<template>
  <div class="bbp-client-projects">
    <div class="bbp-client-projects-header">
      <div>
        <div v-if="projectId"
             class="bbp-client-projects-header__item"
        >
          <div class="bbp-client-projects-header__title">
            <span class="bbp-client-projects-header__title
                         bbp-client-projects-header__title_color"
                  @click="goToProjectList"
            >
              Projects /
            </span>
            <span class="bbp-client-projects-header__title
                         bbp-client-projects-header__title_color"
                  @click="goToClientProjectList"
            >
              {{clientNickname}} /
            </span>
            {{currentProject.name}}
            <div
              v-if="isHourlyProject && totalProjectTime"
              class="bbp-client-projects-header-time"
              @click="onShowHistoryTime"
            >
              <i class="bbp-icon-clock bbp-client-projects-header-buttons__icon
                        bbp-client-projects-header-buttons__icon_small"
              />
              <div class="bbp-client-projects-header-time__text">
                {{totalProjectTime}}
              </div>
            </div>
          </div>
        </div>
        <div v-else class="bbp-client-projects-header__title">
          <span class="bbp-client-projects-header__title
                       bbp-client-projects-header__title_color"
                @click="goToProjectList"
          >
            Projects /
          </span>
          {{titlePage}}
        </div>
      </div>
      <div class="bbp-client-projects-header-buttons">
        <button
          v-if="isHourlyProject"
          class="bbp-button bbp-client-projects-header-buttons__item"
          :disabled="!hasCheckedProjects"
          @mouseenter="showTooltip(1)"
          @mouseleave="hideTooltip"
          @click.stop="openGenerateInvoice = true"
        >
          <BBPIconNewFolder :colorDisabled="colorDisabled"/>
          <transition name="bbp-bounce">
            <BBPTooltip
              v-if="isShowTooltipInvoice"
              :textToolTip="textGenerateInvoice"
            />
          </transition>
        </button>
        <button class="bbp-button
                       bbp-client-projects-header-buttons__item"
                @mouseenter="showTooltip(2)"
                @mouseleave="hideTooltip"
                @click.stop="addProject"
        >
          <i class="bbp-icon-plus
                    bbp-client-projects-header-buttons__icon"/>
          <transition name="bbp-bounce">
            <BBPTooltip :textToolTip="textToolTip"
                        v-if="isShowTooltipProject"/>
          </transition>
        </button>
      </div>
    </div>
    <div class="bbp-client-projects-list">
      <ProjectCard
        class="bbp-client-projects-list__project"
        v-for="(project, projectIndex) in clientProjects"
        :key="project.id"
        :client="client"
        :project="project"
        :hideSubProject="hideSubProject"
        :projectNumber="clientProjects.length - projectIndex"
        :projectIndex="projectIndex"
        :clientProjects="clientProjects"
        :currentProject="currentProject"
        @checked="getIncludesProject"
        @loader="setLoader"
      />
      <StepsNoData @openUpdate="openSubprojectForm"
                   :largeImage="true"
                   :buttonText="buttonAddSubProject"
                   v-if="noData && isHourlyProject"/>
    </div>
    <CompletedProjects class="bbp-client-projects-completed"
                       v-if="!projectId"
                       @loader="setLoader"/>
    <transition name="bbp-fade" appear>
      <BBPLoader v-if="loaderRun"
                 @loader="setLoader"/>
    </transition>
    <transition name="bbp-fade">
      <BBPModalWindow v-if="openProjectForm"
                      @close="closeProjectForm"
      >
        <BBPProjectForm :project="{client}"
                        :subproject="hourlyProject"
                        @close="closeProjectForm"
                        @loader="setLoader"
                        @update="addProjectToList"/>
      </BBPModalWindow>
    </transition>
    <transition name="bbp-fade">
      <BBPModalWindow v-if="openGenerateInvoice"
                      @close="closeGenerateInvoice"
      >
        <BBPGenerateHourlyInvoice
          :projects="projectsToInvoice"
          @close="closeGenerateInvoice"
          @loader="setLoader"
        />
      </BBPModalWindow>
    </transition>
    <transition name="bbp-fade">
      <BBPModalWindow v-if="isShowHistoryTime">
        <BBPTimeHistory
          :project="currentProject"
          :totalProjectTime="totalProjectTime"
          :isShowHistoryTime.sync="isShowHistoryTime"
        />
      </BBPModalWindow>
    </transition>
  </div>
</template>

<script>
import BBPLoader from '@/components/Main/BBPLoader/BBPLoader'
import ProjectsApi from '@/api/Projects/api'
import ProjectCard from '@/components/Projects/ProjectCard/ProjectCard'
import {get, set, omit, orderBy} from 'lodash'
import CompletedProjects from '@/components/Projects/ListOfProjectByClient/CompletedProjects'
import getClient from '@/mixin/getClient'
import {REGULAR, HOURLY, SIDE_HOURLY} from '@/constants/projectTypes'
import BBPTooltip from '@/components/Main/BBPTooltip/BBPTooltip'
import BBPIconClock from '@/components/Main/BBPIcons/BBPIconClock'
import BBPIconNewFolder from '@/components/Main/BBPIcons/BBPIconNewFolder'
import StepsNoData from '@/components/Projects/ProjectCard/StepCard/StepsNoData'
import BBPModalWindow from '@/components/Main/BBPModalWindow/BBPModalWindow'
import BBPProjectForm from '@/components/Projects/ListOfProjects/BBPProjectForm'
import BBPGenerateHourlyInvoice from '@/components/Projects/ListOfProjects/BBPGenerateHourlyInvoice'
import convertSecondsToTime from '@/mixin/convertSecondsToTime'
import BBPTimeHistory from '@/components/Projects/ListOfProjects/BBPTimeHistory/BBPTimeHistory'

export default {
  name: 'ListOfProjectByClient',
  components: {
    BBPGenerateHourlyInvoice,
    CompletedProjects,
    ProjectCard,
    BBPTooltip,
    BBPIconNewFolder,
    BBPIconClock,
    BBPLoader,
    StepsNoData,
    BBPModalWindow,
    BBPProjectForm,
    BBPTimeHistory
  },
  mixins: [getClient, convertSecondsToTime],
  data () {
    return {
      client: {},
      clientProjects: [],
      currentProject: {},
      loaderRun: false,
      isHourlyProject: false,
      noData: false,
      hideSubProject: false,
      textGenerateInvoice: 'Generate invoice',
      openProjectForm: false,
      isShowTooltipInvoice: false,
      isShowTooltipProject: false,
      openGenerateInvoice: false,
      projectsToInvoice: {},
      buttonAddSubProject: 'Add Subproject',
      hasCheckedProjects: false,
      isShowHistoryTime: false
    }
  },
  computed: {
    totalProjectTime () {
      const { totalTime = 0 } = this.currentProject
      const sec = Math.floor(totalTime / 1000)
      if (!this.isHourlyProject || !sec) return false
      return this.convertSecondsToTime(sec, true)
    },
    titlePage () {
      const title = this.projectId ? 'Project' : `${this.clientNickname}`
      const projectName = get(this.currentProject, 'name', '')
      return this.isHourlyProject ? projectName : title
    },
    hourlyProject () {
      const { projectType = {} } = this.currentProject
      return projectType.id === HOURLY.id ? this.currentProject.id : ''
    },
    textToolTip () {
      const { projectType = {} } = this.currentProject
      return projectType.id === HOURLY.id ? 'Add Subproject' : 'Add project'
    },
    colorDisabled () {
      return !this.hasCheckedProjects ? '#0C68A5' : '#FFFFFF'
    },
    projectId () {
      return this.$route.params.projectId
    },
    clientNickname () {
      return get(this.client, 'nickName', '')
    },
    clientId () {
      return this.$route.params.clientId
    },
    projectsList () {
      return this.$store.getters.projectsList
    }
  },
  methods: {
    onShowHistoryTime () {
      this.isShowHistoryTime = !this.isShowHistoryTime
    },
    openSubprojectForm () {
      this.openProjectForm = true
    },
    addProject () {
      this.openProjectForm = true
    },
    closeProjectForm () {
      this.openProjectForm = false
    },
    setLoader (val) {
      this.loaderRun = val
    },
    getIncludesProject ({value, project, steps}) {
      const obj = {project, steps, include: value}
      if (value) {
        set(this.projectsToInvoice, project._id, obj)
      } else {
        this.projectsToInvoice = omit(this.projectsToInvoice, [project._id])
      }
      this.hasCheckedProjects = Object.keys(this.projectsToInvoice).length > 0
    },
    addProjectToList (project) {
      this.clientProjects = orderBy(this.clientProjects.concat([project]), ['dateStart'], ['desc'])
      this.noData = false
    },
    showTooltip (type) {
      if (type === 1) {
        this.isShowTooltipInvoice = true
      } else {
        this.isShowTooltipProject = true
      }
    },
    hideTooltip () {
      this.isShowTooltipInvoice = false
      this.isShowTooltipProject = false
    },
    closeGenerateInvoice () {
      this.openGenerateInvoice = false
    },
    goToProjectList () {
      this.$router.push({name: 'ListOfProjects'})
    },
    goToClientProjectList () {
      const getClientIdFrom = this.isHourlyProject ? this.currentProject : this.clientProjects
      const pathClientId = this.isHourlyProject ? ['client', 'id'] : [0, 'client', 'id']
      const clientId = get(getClientIdFrom, pathClientId, '')
      this.$router.push({name: 'ListOfProjectByClient', params: {clientId: clientId}})
      this.getProjectsByClient()
    },
    getProjectsByClient () {
      this.isHourlyProject = false
      this.hideSubProject = false
      this.setFullClient(this.clientId)
      this.loaderRun = true
      this.currentProject = {}
      ProjectsApi.getProjects({client: this.clientId, status: '1', projectType: '1&projectType[]=2'})
        .then(({ data }) => {
          this.loaderRun = false
          const { projects = [] } = data
          const projectTypes = [REGULAR, HOURLY, SIDE_HOURLY]
          projects.forEach((item) => {
            item.projectType = projectTypes.find((el) => el.id === item.projectType)
          })
          this.clientProjects = projects
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    getProjectById () {
      this.loaderRun = true
      ProjectsApi.getProjectById(this.projectId)
        .then(({ data }) => {
          const { client, childrenProjects } = data
          this.setFullClient(client)
          this.isHourlyProject = get(data, ['projectType'], '') === HOURLY.id
          const projectTypes = [REGULAR, HOURLY, SIDE_HOURLY]
          data.projectType = projectTypes.find((el) => el.id === data.projectType)
          this.currentProject = data
          if (this.isHourlyProject) {
            childrenProjects.forEach((item) => {
              item.projectType = projectTypes.find((el) => el.id === item.projectType)
            })
            this.clientProjects = childrenProjects
            this.noData = !childrenProjects.length
            this.hideSubProject = true
            this.loaderRun = false
          } else {
            this.clientProjects = [data]
            this.loaderRun = false
          }
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    async setFullClient (clientId) {
      if (typeof clientId === 'object') {
        this.client = clientId
        return
      }
      this.client = await this.getClient(clientId)
    }
  },
  watch: {
    clientProjects (newVal) {
      if (!newVal.length) this.noData = true
    },
    $route () {
      this.projectId ? this.getProjectById() : this.getProjectsByClient()
    },
    projectsList () {
      if (!this.projectId) this.getProjectsByClient()
    }
  },
  beforeMount () {
    this.projectId ? this.getProjectById() : this.getProjectsByClient()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbp-client-projects {
    display: grid;
    @include global-font;

    &-header {
      position: relative;
      display: grid;
      grid-template-columns: repeat(2, auto);
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;

      &__item {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      &__block {
        border-radius: 4px;
        padding: 4px 6px;
        background-color: $color-link-water;
        color: $color-denim;
      }

      &__title {
        color: $color-accent;
        font-weight: 600;
        font-size: 18px;
        line-height: 21px;
        display: flex;
        align-items: center;

        &_color {
          margin-right: 4px;
          color: $color-tundora;
          font-size: 16px;
          line-height: 19px;
          cursor: pointer;
          transition: .3s linear;

          &:hover {
            color: $color-accent-hover;
            transition: .3s linear;
          }
        }

        &_client {
          position: absolute;
          top: -20px;
          left: 0;
          margin-bottom: 10px;
        }
      }

      &-buttons {
        display: grid;
        max-width: 144px;
        grid-template-columns: repeat(auto-fit, 42px);
        align-items: center;
        grid-gap: 9px;

        &__icon {
          font-size: 18px;

          &_small {
            font-size: 14px;
            margin: 0 3px 0 0;

            &:before {
              margin: 0;
            }
          }
        }

        &__item {
          display: flex;
          justify-content: center;
          align-items: center;
          white-space: nowrap;
          width: 42px;
          height: 42px;
          border-radius: 50%;
        }
      }
    }

    &-list {
      display: grid;
      grid-gap: 20px;
    }

    &-completed {
      margin-top: 30px;
    }
  }

  .bbp-client-projects-header-time {
    display: flex;
    align-items: center;
    margin: 0 0 0 11px;
    cursor: pointer;
    transition: 0.15s;

    &:hover {
      opacity: 0.8;
    }

    &__text {
      font-size: 14px;
      line-height: 17px;
      font-weight: 600;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Projects/ListOfProjectByClient/ListOfProjectByClient.vue